import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dd7ff47a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=dd7ff47a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7ff47a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd7ff47a')) {
      api.createRecord('dd7ff47a', component.options)
    } else {
      api.reload('dd7ff47a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dd7ff47a&scoped=true", function () {
      api.rerender('dd7ff47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/svg-icon-nc/index.vue"
export default component.exports